// extracted by mini-css-extract-plugin
export default {"container":"Relationships_container__EnxUd","noParent":"Relationships_noParent__9LwyE","sectionTitle":"Relationships_sectionTitle__zE5fa"};